import { format } from 'date-fns';

// 期間の表示
export const dateRange = (
  startDateInput: string | null | undefined,
  endDateInput: string | null | undefined,
): string => {
  const checkAndFormatDate = (dateInput: string | null | undefined): string => {
    if (dateInput === null || dateInput === undefined) {
      return '';
    }

    const date = new Date(dateInput);
    if (Number.isNaN(date.getTime())) {
      // 日付が無効な場合は入力された値をそのまま返します。
      return dateInput;
    }

    // 日付が有効な場合はフォーマットします。
    return format(date, 'yyyy/MM/dd');
  };

  const startDate = checkAndFormatDate(startDateInput);
  const endDate = checkAndFormatDate(endDateInput);

  // 両方の日付が無効（入力されなかった場合を含む）なら空文字を返します。
  if (!startDate && !endDate) {
    return '';
  }

  return `${startDate} ~ ${endDate}`;
};

// 日付の表示
export const dateformat = (dateInput: string | null | undefined): string => {
  if (!dateInput) return '';

  const date = new Date(dateInput);
  // 有効な日付でない場合、getTime() は NaN を返す
  if (Number.isNaN(date.getTime())) {
    return dateInput; // または何らかのエラーメッセージを返す
  }

  return format(date, 'yyyy/MM/dd');
};

export default dateRange;
